export default {
  benefits: [],
  selectedBenefit: null,
  benefitGroups: [],
  benefitTypeScroll: null,
  error: false,
  errorMessage: ''
}